if (document.getElementById("map") !== null) {
  var map;
  var markers = [];
  var pins = JSON.parse(
    document.getElementById("map").getAttribute("data-pins")
  );
  var bounds = new google.maps.LatLngBounds();
}

// Fonction d'initialisation de la Google Map
function initMap() {
  if (document.getElementById("map") == null) return;

  map = new google.maps.Map(document.getElementById("map"), {
    zoom: 7,
    center: { lat: 50.85, lng: 4.35 }, // Coordonnées pour centrer la carte (ex. Bruxelles)
  });

  // Afficher tous les pins par défaut
  displayPins(pins);
  displayList(pins); // Afficher la liste initialement
}

// Fonction pour afficher les pins sur la carte
function displayPins(pins) {
  // Supprimer les anciens marqueurs
  clearMarkers();

  bounds = new google.maps.LatLngBounds();

  pins.forEach(function(pin) {
    var marker = new google.maps.Marker({
      position: { lat: pin.lat, lng: pin.lng },
      map: map,
      title: pin.title,
    });

    markers.push(marker);
    bounds.extend({ lat: pin.lat, lng: pin.lng });

    var infowindow = new google.maps.InfoWindow({
      content: `
          <div class="map-info-container">
              <img src="${pin.picture}"/>    
              <a href="${pin.url}">${pin.title}</a>
          </div>
      `,
    });

    marker.addListener("click", function() {
      infowindow.open(map, marker);
    });
  });
  console.log(bounds);

  // Ajuster les limites de la carte pour cadrer les marqueurs visibles
  map.fitBounds(bounds);
}

// Supprimer tous les marqueurs de la carte
function clearMarkers() {
  markers.forEach(function(marker) {
    marker.setMap(null);
  });
  markers = [];
}

// Fonction pour calculer la distance entre deux points géographiques
function calculateDistance(lat1, lng1, lat2, lng2) {
  var R = 6371; // Rayon de la Terre en km
  var dLat = ((lat2 - lat1) * Math.PI) / 180;
  var dLng = ((lng2 - lng1) * Math.PI) / 180;
  var a =
    0.5 -
    Math.cos(dLat) / 2 +
    (Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      (1 - Math.cos(dLng))) /
      2;
  return R * 2 * Math.asin(Math.sqrt(a));
}

// Fonction pour afficher ou masquer les éléments de la liste en fonction des pins filtrés
function displayList(filteredPins) {
  // Masquer tous les éléments de la liste
  document.querySelectorAll(".views-row").forEach(function(row) {
    row.style.display = "none";
  });

  // Montrer uniquement les éléments de la liste qui correspondent aux pins filtrés
  filteredPins.forEach(function(pin) {
    var estateRow = document.getElementById("estate-" + pin.id);
    if (estateRow) {
      estateRow.style.display = "block"; // Afficher l'élément correspondant
    }
  });
}

function handlerFormFilter() {
  var minPrice = document.getElementById("minPrice").value;
  var maxPrice = document.getElementById("maxPrice").value;
  sessionStorage.setItem("minPrice", minPrice);
  sessionStorage.setItem("maxPrice", maxPrice);
  //parse float is not empty
  if (minPrice !== "") {
    minPrice = parseFloat(minPrice);
  } else {
    minPrice = 0;
  }
  if (maxPrice !== "") {
    maxPrice = parseFloat(maxPrice);
  } else {
    maxPrice = 999999999999;
  }

  var location = document.getElementById("location").value.trim();
  var filteredPins = pins;

  sessionStorage.setItem("location", location);
  // Filtrer les pins par prix
  filteredPins = pins.filter(function(pin) {
    return pin.price >= minPrice && pin.price <= maxPrice;
  });

  // Si une commune ou un code postal est spécifié
  if (location !== "") {
    location = location + ", Belgium"; // Ajouter la Belgique pour éviter les conflits avec d'autres pays
    // Utiliser l'API Geocoding pour obtenir les coordonnées de la commune ou du code postal
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: location }, function(results, status) {
      if (status === "OK") {
        var centerLat = results[0].geometry.location.lat();
        var centerLng = results[0].geometry.location.lng();
        // Filtrer les pins dans un rayon de 30 km
        filteredPins = filteredPins.filter(function(pin) {
          var distance = calculateDistance(
            centerLat,
            centerLng,
            pin.lat,
            pin.lng
          );

          return distance <= 30; // Rayon de 30 km
        });
        // Afficher les pins filtrés sur la carte et dans la liste
        displayPins(filteredPins);
        displayList(filteredPins);
      } else {
        alert("Geocode was not successful for the following reason: " + status);
      }
    });
  } else {
    // Si pas de localisation, afficher simplement les pins filtrés par prix
    displayPins(filteredPins);
    displayList(filteredPins);
  }
}

// Traiter la soumission du formulaire de filtrage
if (document.getElementById("filterFormMap") !== null) {
  document
    .getElementById("filterFormMap")
    .addEventListener("submit", function(e) {
      e.preventDefault();
      handlerFormFilter();
    });
}

// Charger la carte lorsque la page est chargée
document.addEventListener("DOMContentLoaded", function() {
  initMap();
  //On document loaded and if session storage is not empty and if filterFormMap exists
  if (document.getElementById("filterFormMap") !== null) {
    // Parse float is not empty

    let minPrice = parseFloat(sessionStorage.getItem("minPrice"));
    let maxPrice = parseFloat(sessionStorage.getItem("maxPrice"));
    let location = sessionStorage.getItem("location");
    // Set values of minPrice and maxPrice
    //if minPrice is not empty
    if (!isNaN(minPrice)) {
      document.getElementById("minPrice").value = minPrice;
    }
    if (!isNaN(maxPrice)) {
      document.getElementById("maxPrice").value = maxPrice;
    }
    if (location !== null && location !== "") {
      document.getElementById("location").value = location;
    }
    if (!isNaN(maxPrice) || !isNaN(minPrice) || location !== "") {
      handlerFormFilter();
    }
  }
});
